import type { Theme, SxProps } from '@mui/material/styles';

import { m } from 'framer-motion';
import { ForbiddenIllustration } from '@classroom-ai/ui/assets/illustrations';
import { varBounce, MotionContainer } from '@classroom-ai/ui/components/animate';
import { SignOutButton } from '@classroom-ai/ui/layouts/components/sign-out-button';

import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

// ----------------------------------------------------------------------

/**
 * NOTE:
 * This component is for reference only.
 * You can customize the logic and conditions to better suit your application's requirements.
 */

export type RoleBasedGuardProp = {
  sx?: SxProps<Theme>;
  currentRole: string;
  hasContent?: boolean;
  allowedRoles: string | string[];
  children: React.ReactNode;
};

export function RoleBasedGuard({
  sx,
  children,
  hasContent,
  currentRole,
  allowedRoles,
}: RoleBasedGuardProp) {
  if (!currentRole || !allowedRoles.includes(currentRole)) {
    return hasContent ? (
      <Container
        component={MotionContainer}
        sx={[{ textAlign: 'center' }, ...(Array.isArray(sx) ? sx : [sx])]}
      >
        <m.div variants={varBounce('in')}>
          <Typography variant="h3" sx={{ mb: 2 }}>
            Permission denied
          </Typography>
        </m.div>

        <m.div variants={varBounce('in')}>
          <Typography sx={{ color: 'text.secondary' }}>
            You do not have permission to access this page.
          </Typography>
        </m.div>

        <m.div variants={varBounce('in')}>
          <ForbiddenIllustration sx={{ my: { xs: 5, sm: 10 } }} />
        </m.div>

        <m.div variants={varBounce('in')}>
          <Box sx={{ maxWidth: 220, mx: 'auto' }}>
            <SignOutButton />
          </Box>
        </m.div>
      </Container>
    ) : null;
  }

  return <> {children} </>;
}
